import { render, staticRenderFns } from "./StyleAssortment.vue?vue&type=template&id=23df33f4&scoped=true&"
import script from "./StyleAssortment.vue?vue&type=script&lang=js&"
export * from "./StyleAssortment.vue?vue&type=script&lang=js&"
import style0 from "./StyleAssortment.vue?vue&type=style&index=0&id=23df33f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23df33f4",
  null
  
)

export default component.exports